export default __webpack_public_path__ + "static/media/option-haard-plast.7dce411d.svg";